<template>
  <div class="comp">
    <template v-for="(line, index) in textLineList">
      <span v-html="line" :key="'s' + index"></span
      ><br :key="'br' + index" v-if="index < textLineList.length - 1" />
    </template>
  </div>
</template>

<script>
export default {
  name: "preDiv",
  props: {
    text: {},
  },
  data() {
    return {};
  },
  computed: {
    textLineList() {
      if (!this.text) {
        return [];
      }
      let list = this.text.split("\n");
      return list.map((line) =>
        line
          .replace(/&/g, "&amp;")
          .replace(/\s/g, "&nbsp;")
          .replace(/</g, "&lt;")
          .replace(/>/g, "&gt;")
      );
    },
  },
  watch: {},
  methods: {},
  components: {},
  mounted() {},
  created() {},
};
</script>

  <style lang="scss" scoped>
.comp {
  word-break: break-all;
}
</style>
